import { useSelector, useDispatch } from "react-redux"
import ScheduleItem from "./ScheduleItem"
import { scheduleHover, projectActions, limsReviews } from "state_management"
import dragTypes from "utils/scripts/dragTypes"

export default function ScheduleAction({ actionId, shouldShowState, style, onClick, view, showIcons }) {
  const dispatch = useDispatch()
  const action = useSelector((state) => state.projectActions.plannedProjectActions[actionId])
  const isActive = useSelector((state) => action ? state.scheduleHover.projectId === action.projectId : false)
  const project = useSelector((state) => action ? state.projects[action.projectId] : null)
  const constraintChecks = useSelector((state) => state.constraintChecks[actionId]) || []
  const assets = useSelector((state) => state.asset.assets)
  // PRD-003 Area 1 / SPEC-007: a planned review action opens the analysis it reviews (not the
  // default single-action config), so the reviewer lands on the analysis's results/review surface.
  // SPEC-044: explicitly gated on showLims — a non-LIMS team must never take the LIMS review
  // redirect. (limsReviews.items is empty for them anyway; the gate makes the decoupling explicit
  // rather than dependent on the slice happening to be empty. Mirrors ScheduleAnalysisTask.)
  const review = useSelector((state) =>
    state.teamStatus.showLims ? state.limsReviews.items.find((r) => r.actionId === actionId) || null : null
  )

  // If action is not found in planned actions, it may have been unplanned
  if (!action || !project) {
    return null
  }

  const handleClick = review ? () => dispatch(limsReviews.openReviewAnalysis(review.analysisId)) : onClick

  return (
    <ScheduleItem
      item={action}
      backgroundColor={project.color}
      shouldShowState={shouldShowState}
      style={style}
      isActive={isActive}
      onMouseEnter={() => dispatch(scheduleHover.setProjectId(action.projectId))}
      onMouseLeave={() => dispatch(scheduleHover.setProjectId(null))}
      onClick={handleClick}
      dragType={dragTypes.ACTION}
      name={project.singleActionProject ? action.name : `${project.name}: ${action.name}`}
      description={action.description}
      state={action.stage}
      constraintChecks={constraintChecks}
      movable={action.movable}
      setMovable={(movable) => dispatch(projectActions.setMovable(action.id, movable))}
      view={view}
      assetName={action.assetIds.length ? assets[action.assetIds[0]].name : ""}
      showIcons={showIcons}
    />
  )
}
